import React, { useEffect, useState } from "react";
import { createAction } from "@reduxjs/toolkit";
import { useHistory } from "react-router-dom";
import store from "../../app/store";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import PaginationManager from "../../view/PaginationManager";
import ConfigChangesTable from "./ConfigChangesTable";
import ConfigChangesTableHeader from "./ConfigChangesTableHeader";
import ConfigChangesComparison from "./ConfigChangesComparison"
import * as configChangesService from "./configChangesService";
import { ACTION_CONFIGCHANGESRESULT_CHANGED } from "./ConfigChangesPageReducer";

function ConfigChangesTableSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true,
        selectedDevice: null,
        disabled: true,
        detectDate: new Date()
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    useEffect(() => {
        store.dispatch(createAction(ACTION_CONFIGCHANGESRESULT_CHANGED)({configChangesResult: []}));
    }, []);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <ConfigChangesTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <ConfigChangesTable />
                                            <PaginationManager getPage={configChangesService.listPageable} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfigChangesComparison />
        </TableContext.Provider>
    )
}

export default ConfigChangesTableSection;
